// §6.1 — the house skin (D-030, D-044): Hangar's own identity and the anonymous default.
//
// Neutral, minimal chrome, dark by default with a warm amber accent — deliberately neither
// Windows blue nor macOS blue, so the public front door is not a clone of anything.
import type { UiSkin } from '../contract';
import tokens from './tokens.css?inline';
import './skin.css';
import { houseKeymap } from './keymap';
import { housePolicy } from './policy';
import { houseSounds } from './sounds';
import { WindowFrame } from './components/WindowFrame';
import { DesktopSurface } from './components/DesktopSurface';
import { Bar } from './components/Bar';
import { Launcher } from './components/Launcher';
import { Dialog } from './components/Dialog';
import { Switcher } from './components/Switcher';
import { LockScreen, LoginScreen, NotificationHost, TrayFlyout } from './components/misc';

export const houseSkin: UiSkin = {
  id: 'house',
  label: 'Hangar',
  tokens,
  keymap: houseKeymap,
  policy: housePolicy,
  sounds: houseSounds,
  components: {
    DesktopSurface,
    Bar,
    Launcher,
    WindowFrame,
    Dialog,
    NotificationHost,
    Switcher,
    TrayFlyout,
    LoginScreen,
    LockScreen,
  },
};
